import _ from '@lodash';
import * as Actions from '../Actions/EmpresaPessoaOrcamentoActions';
const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
    novopedido: null,
    template: null,
    formDialog: {
        type: 'new',
        props: {
            open: false,
        },
        data: null,
    }
};


const EmpresaPessoaOrcamentoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAPESSOA_FORMULARIO:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.GET_EMPRESAPESSOA_FORMULARIO_TEMPLATE:
            {
                return {
                    ...state,
                    template: action.payload

                };
            }
        case Actions.OPEN_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'new',
                        props: {
                            open: true
                        },
                        data: null
                    }
                };
            }
        case Actions.CLOSE_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'new',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.OPEN_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'edit',
                        props: {
                            open: true
                        },
                        data: action.data
                    }
                };
            }
        case Actions.CLOSE_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'edit',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAPESSOA_FORMULARIO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.EMPRESAPESSOA_FORMULARIO_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    novopedido: !_.isUndefined(action.novopedido) && !_.isNull(action.novopedido) ? action.novopedido : null,
                    formDialog: {
                        ...state.formDialog,
                        props: {
                            ...state.formDialog.props,
                            id: action.id
                        }
                    }
                };
            }
        case Actions.EMPRESAPESSOA_FORMULARIO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default EmpresaPessoaOrcamentoReducer;
